import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Button,
  TextField,
  InputAdornment,
  IconButton,
  Container,
  Autocomplete,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { NavLink, useParams, Link } from "react-router-dom";
import AlertMessage from "./modules/AlertMessage";
import arrowRightPurple from "../image/icon/arrowRightPurple.png";
import arrowLeftPurple from "../image/icon/arrowLeftPurple.png";
import SearchIcon from "@mui/icons-material/Search";
import "../styles/navLink.css";
import { usePrice } from "./modules/PhonePriceListContext";

export default function ModemPriceList() {
  const { t, i18n } = useTranslation();
  const [alert, setAlert] = useState({
    alertCheck: false,
    message: "",
    severity: "",
  });
  const { modemData } = usePrice();
  const [searchTerm, setSearchTerm] = useState("");
  const [result, setResult] = useState(modemData);
  const params = useParams();
  const [chooseModel, setChooseModel] = useState(null);
  const [chooseSort, setChooseSort] = useState(null);
  const options = [
    { label: i18n.language === "fa" ? "همه" : "All products", id: 3 },
    { label: i18n.language === "fa" ? "نتربیت" : "Neterbit", id: 1 },
    { label: i18n.language === "fa" ? "ایرانسل" : "Irancell", id: 2 },
    // { label: i18n.language === "fa" ? 'ایسر' : "ASER", id: 5 },
    // { label: i18n.language === "fa" ? 'دل' : "DELL", id: 6 },
    // { label: i18n.language === "fa" ? 'ام اس آی' : "MSI", id: 7 },
  ];

  const sortOption = [
    { label: i18n.language === "fa" ? "همه" : "All", id: 1 },
    {
      label: i18n.language === "fa" ? "کمترین قیمت" : "The lowest price",
      id: 2,
    },
    {
      label: i18n.language === "fa" ? "بیشترین قیمت" : "The highest price",
      id: 3,
    },
  ];

  useEffect(() => {
    setResult(modemData);
  }, [modemData]);

  useEffect(() => {
    applyFiltersAndSorting();
  }, [searchTerm, chooseModel, chooseSort, modemData]);

  const applyFiltersAndSorting = () => {
    let filteredData = [...modemData];

    if (chooseModel) {
      if (chooseModel.id === 3) {
        filteredData = filteredData;
      } else {
        filteredData = filteredData.filter(
          (item) =>
            item.brand.name_fa
              .toLowerCase()
              .includes(chooseModel.label.toLowerCase()) ||
            item.brand.name_en
              .toLowerCase()
              .includes(chooseModel.label.toLowerCase()),
        );
      }
    }

    if (searchTerm) {
      filteredData = filteredData.filter(
        (item) =>
          item.brand.name_fa.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.brand.name_en.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.model.name.toLowerCase().includes(searchTerm.toLowerCase()),
      );
    }

    if (chooseSort) {
      if (chooseSort.id === 2) {
        filteredData.sort((a, b) => {
          const priceA = parseInt(a.price);
          const priceB = parseInt(b.price);
          if (priceA === 0) return 1;
          if (priceB === 0) return -1;
          return priceA - priceB;
        });
      } else if (chooseSort.id === 3) {
        filteredData.sort((a, b) => {
          return parseInt(b.price) - parseInt(a.price);
        });
      } else {
        filteredData = filteredData;
      }
    }

    setResult(filteredData);
  };

  const handleChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const separator = (value) => {
    value = value.toString();
    var place = 0;
    if (value.includes(".")) {
      place = value.indexOf(".");
      var num1 = value.slice(0, place);
      var num2 = value.slice(place + 1, value.length);
      value = camaInsert(num1, false) + "." + camaInsert(num2, true);
    } else {
      value = camaInsert(value);
    }
    return value;
  };

  function camaInsert(value, after = false) {
    var output = [];
    var outputString = "";
    if (after) {
      for (var i = 1; i <= value.length; i++) {
        if (i % 3 === 0) {
          output.push(value.slice(i - 3, i));
        }
      }
      if (value.length % 3 !== 0) {
        output.push(
          value.slice(value.length - (value.length % 3), value.length),
        );
      }

      for (var j = 0; j < output.length; j++) {
        if (j + 1 < output.length) {
          outputString = outputString + output[j] + ",";
        } else {
          outputString = outputString + output[j];
        }
      }
    } else {
      for (var p = 1; p <= value.length; p++) {
        if (p % 3 === 0) {
          output.push(value.slice(value.length - p, value.length - p + 3));
        }
      }
      if (value.length % 3 !== 0) {
        output.push(value.slice(0, value.length % 3));
      }
      for (var o = output.length - 1; o >= 0; o--) {
        if (o > 0) {
          outputString = outputString + output[o] + ",";
        } else {
          outputString = outputString + output[o];
        }
      }
    }
    return outputString;
  }

  const mapOnData = () => {
    let res = [];
    const cardWidth = "300px";
    result &&
      result.map((item, index) => {
        const imagePath =
          item.image && item.image.length > 0 ? item.image[0].path : "";
        const titleFa =
          item.brand && item.model
            ? `${item.group.name_fa} ${item.brand.name_fa} مدل ${item.model.name} `
            : "";
        const titleEn =
          item.brand && item.model
            ? `${item.group.name_en} ${item.brand.name_en} model ${item.model.name} `
            : "";
        const priceString = item.price !== 0 && item.price;
        const spot = parseInt(priceString) + parseInt(0.03 * priceString);
        const cash = parseInt(priceString) + parseInt(0.057 * priceString);
        const total = parseInt(priceString) + parseInt(0.057 * priceString);
        // const pish = parseInt(total) * 0.35;
        const pish =
          parseInt(total) < 100000000
            ? parseInt(total) * 0.4
            : parseInt(total) >= 100000000 && parseInt(total) <= 200000000
              ? parseInt(total) * 0.5
              : parseInt(total) > 200000000
                ? parseInt(total) * 0.6
                : 0;
        const baghi = parseInt(total) - parseInt(pish);
        const soud = parseInt(baghi) * 0.035;
        res.push(
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={3}
            style={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
              maxWidth: cardWidth,
            }}
            key={index}
          >
            <Button
              component={Link}
              disableRipple={true}
              target="_blank"
              to={`/ModemPriceList/${item.id}/${item.brand.name_en}${item.model.name}`}
              sx={{
                textDecoration: "none",
                color: "black",
                display: "block",
                width: "100%",
                padding: "0",
                "&:hover": {
                  bgcolor: "transparent",
                  boxShadow: "0px 0px 16px 0px #FF3951",
                },
              }}
            >
              <Grid
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  boxShadow: "0px 0px 16px 0px #c6cecc ",
                  borderRadius: "15px",
                  height: "600px",
                  justifyContent: "space-evenly",
                }}
              >
                <Typography
                  component={"img"}
                  src={imagePath}
                  alt={`${titleFa}${index}`}
                  sx={{ width: "95%", height: "30%", borderRadius: "10px" }}
                />
                <Typography
                  component={"h2"}
                  style={{
                    color: "black",
                    width: "90%",
                    alignSelf: "center",
                    fontWeight: 600,
                  }}
                >
                  {i18n.language === "fa" ? titleFa : titleEn}
                </Typography>
                <Grid
                  sx={{
                    width: "90%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    direction: i18n.language === "fa" ? "rtl" : "ltr",
                  }}
                >
                  <Typography sx={{ color: "#FF3951" }}>
                    {t("consumerPrice")}
                  </Typography>
                  <Typography sx={{ color: "#FF3951", fontWeight: "bold" }}>
                    {cash !== 0
                      ? `${separator(cash)} ${t("toman")}`
                      : t("outOfStock")}
                  </Typography>
                </Grid>
                <Grid
                  sx={{
                    width: "90%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    direction: i18n.language === "fa" ? "rtl" : "ltr",
                  }}
                >
                  <Typography sx={{ color: "#f88e2bff" }}>
                    {t("spotSalePrice")}
                  </Typography>
                  <Typography sx={{ color: "#f88e2bff", fontWeight: "bold" }}>
                    {spot !== 0
                      ? `${separator(spot)} ${t("toman")}`
                      : t("outOfStock")}
                  </Typography>
                </Grid>
                <Grid
                  sx={{
                    width: "90%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    direction: i18n.language === "fa" ? "rtl" : "ltr",
                  }}
                >
                  <Typography
                    sx={{
                      display: "flex",
                      alignSelf: "flex-start",
                      fontWeight: "bold",
                      fontSize: "20px",
                      color: "#7F04FB",
                    }}
                  >
                    {t("aqsat")}
                  </Typography>
                  <Typography>
                    {i18n.language === "fa"
                      ? item.color.name_fa
                      : item.color.name_en}
                  </Typography>
                </Grid>
                <Grid
                  sx={{
                    width: "90%",
                    height: "1px",
                    backgroundColor: "#BABABA",
                  }}
                ></Grid>
                <Grid
                  sx={{
                    width: "90%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    direction: i18n.language === "fa" ? "rtl" : "ltr",
                  }}
                >
                  <Typography sx={{ fontWeight: 600 }}>
                    {t("prepayment")}
                  </Typography>
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      fontSize: i18n.language === "fa" ? "15px" : "10px",
                    }}
                  >
                    {pish !== 0
                      ? `${separator(Math.floor(pish))} ${t("toman")}`
                      : t("outOfStock")}
                  </Typography>
                </Grid>
                {qestHarMah(baghi, soud)}
              </Grid>
            </Button>
          </Grid>,
        );
      });
    return res;
  };

  const month = [3, 4, 5, 6];
  const qestHarMah = (total, soud) => {
    let result = [];
    month.map((element, i) => {
      const qest = Math.round((total + soud * element) / element);
      result.push(
        <>
          <Grid
            key={i}
            sx={{
              width: "90%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              direction: i18n.language === "fa" ? "rtl" : "ltr",
            }}
          >
            <Typography
              sx={{ fontSize: i18n.language === "fa" ? "15px" : "10px" }}
            >{`${element} ${t("month")}`}</Typography>
            <Typography
              sx={{
                fontWeight: "bold",
                fontSize: i18n.language === "fa" ? "15px" : "10px",
              }}
            >{`${separator(qest)} ${t("toman")}`}</Typography>
          </Grid>
        </>,
      );
    });
    return result;
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    return setAlert({
      alertCheck: false,
      message: "",
      severity: alert.severity,
    });
  };

  const onchangeModel = (event, value) => {
    setChooseModel(value);
    setSearchTerm("");
  };

  const onchangeSort = (event, value) => {
    setChooseSort(value);
    setSearchTerm("");
  };

  return (
    <>
      <Grid
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          width: "100%",
          direction: i18n.language === "fa" ? "rtl" : "ltr",
        }}
      >
        <Grid
          sx={{
            display: "flex",
            width: "100%",
            backgroundColor: "#EDEDED",
            padding: "15px 0",
            justifyContent: "center",
          }}
        >
          <Grid
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              alignItems: "center",
              width: { xs: "95%", md: "86%" },
            }}
          >
            <NavLink className="navlink" to="/">
              <Typography
                component={"p"}
                sx={{ fontSize: "12px", color: "#757575", padding: "0 5px" }}
              >
                {t("mainPage")}
              </Typography>
            </NavLink>
            <ArrowBackIosIcon sx={{ fontSize: "15px" }} />
            <Typography
              component={"p"}
              sx={{ fontSize: "12px", color: "#070707", padding: "0 5px" }}
            >
              {t("ModemPriceList")}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: { xs: "80px", sm: "150px" },
            mt: "1%",
          }}
        >
          <Typography
            component={"img"}
            alt="icon"
            src={arrowRightPurple}
            sx={{
              width: { xs: "17px", sm: "39px", md: "40px", lg: "54px" },
              height: { xs: "17px", sm: "53px", md: "55px", lg: "69px" },
              margin: "0 3px",
            }}
          />
          <Typography
            component={"h1"}
            sx={{
              fontWeight: "bold",
              fontSize: { xs: "17px", sm: "24px", md: "32px" },
            }}
          >
            {t("ModemPriceList")}
          </Typography>
          <Typography
            component={"img"}
            alt="icon"
            src={arrowLeftPurple}
            sx={{
              width: { xs: "17px", sm: "39px", md: "40px", lg: "54px" },
              height: { xs: "17px", sm: "53px", md: "55px", lg: "69px" },
              margin: "0 3px",
            }}
          />
        </Grid>
        <Grid
          sx={{
            width: "70%",
            justifyContent: { xs: "center", md: "space-between" },
            mt: "1.5%",
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <TextField
            variant="outlined"
            placeholder={t("search")}
            value={searchTerm}
            onChange={handleChange}
            // onKeyPress={handleKeyPress}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton aria-label="search">
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            sx={{
              width: { xs: "100%", md: "30%", lg: "30%" },
              alignSelf: "center",
              "& .MuiOutlinedInput-root": {
                borderRadius: "20px",
                boxShadow: "2px 2px 10px #FF3951",
                border: "unset",
              },
            }}
          />
          <Autocomplete
            value={chooseModel}
            onChange={onchangeModel}
            options={options}
            getOptionLabel={(option) => option.label}
            // size={textFieldSize}
            sx={{
              width: {
                xs: "100%",
                sm: "100%",
                md: "22%",
                lg: "20%",
                xl: "20%",
              },
              "& .MuiInputBase-root fieldset": {
                borderRadius: "20px",
                boxShadow: "2px 2px 10px #FF3951",
              },
              backgroundColor: "background.main",
              borderRadius: "14px",
              "& .MuiAutocomplete-endAdornment": {
                left:
                  i18n.language === "fa"
                    ? "7px !important"
                    : "unset !important",
                right:
                  i18n.language === "fa"
                    ? "unset !important"
                    : "7px !important",
              },
              "& .MuiMenuItem-root": { justifyContent: "flex-end" },
              "& .MuiSvgIcon-root": { color: "text.greenLight" },
              margin: "30px 0",
            }}
            renderOption={(props, option) => (
              <Grid {...props} sx={{ width: "100%" }}>
                <Typography
                  sx={{
                    width: "100%",
                    fontSize: "17px",
                    textAlign: i18n.language === "fa" ? "right" : "left",
                  }}
                >
                  {option.label}
                </Typography>
                {option.iban}
              </Grid>
            )}
            renderInput={(params) => (
              <TextField
                className="textField"
                {...params}
                label={t("chooseModemModel")}
                InputProps={{
                  ...params.InputProps,
                  type: "search",
                  style: {
                    textAlign: "left",
                    paddingRight: "10px",
                    fontSize: "20px",
                  },
                }}
              />
            )}
          />
          <Autocomplete
            value={chooseSort}
            onChange={onchangeSort}
            options={sortOption}
            getOptionLabel={(option) => option.label}
            // size={textFieldSize}
            sx={{
              width: {
                xs: "100%",
                sm: "100%",
                md: "22%",
                lg: "20%",
                xl: "20%",
              },
              "& .MuiInputBase-root fieldset": {
                borderRadius: "20px",
                boxShadow: "2px 2px 10px #FF3951",
              },
              backgroundColor: "background.main",
              borderRadius: "14px",
              "& .MuiAutocomplete-endAdornment": {
                left:
                  i18n.language === "fa"
                    ? "7px !important"
                    : "unset !important",
                right:
                  i18n.language === "fa"
                    ? "unset !important"
                    : "7px !important",
              },
              "& .MuiMenuItem-root": { justifyContent: "flex-end" },
              "& .MuiSvgIcon-root": { color: "text.greenLight" },
              margin: "10px 0",
            }}
            renderOption={(props, option) => (
              <Grid {...props} sx={{ width: "100%" }}>
                <Typography
                  sx={{
                    width: "100%",
                    fontSize: "17px",
                    textAlign: i18n.language === "fa" ? "right" : "left",
                  }}
                >
                  {option.label}
                </Typography>
                {option.iban}
              </Grid>
            )}
            renderInput={(params) => (
              <TextField
                className="textField"
                {...params}
                label={t("filter")}
                InputProps={{
                  ...params.InputProps,
                  type: "search",
                  style: {
                    textAlign: "left",
                    paddingRight: "10px",
                    fontSize: "20px",
                  },
                }}
              />
            )}
          />
          <Grid
            sx={{
              bgcolor: "#FF3951",
              width: { xs: "60%", sm: "40%", md: "20%", lg: "15%", xl: "20%" },
              height: { xs: "40px", sm: "45px", md: "50px", lg: "65px" },
              boxShadow: " #FF3951 0px 0px 15px",
              "&:hover": { backgroundColor: "#FF3951" },
              mt: { xs: "15px", md: "0px" },
              borderRadius: "8px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <NavLink
              to="/InstallmentSales"
              className="navlink"
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "row",
                width: "100%",
                justifyContent: "center",
                color: "white",
                textAlign: "center",
              }}
            >
              <Typography
                sx={{
                  fontSize: {
                    xs: "8px",
                    sm: "14px",
                    md: "16px",
                    lg: "18px",
                    xl: "20px",
                  },
                }}
              >
                {t("installmentCondition")}
              </Typography>
            </NavLink>
          </Grid>
        </Grid>
        <Container
          sx={{
            width: "90%",
            margin: "0 auto",
            display: "flex",
            justifyContent: "space-between",
            mt: "2.5%",
          }}
          maxWidth={"1800px"}
        >
          <Grid
            container
            spacing={3}
            justifyContent="center"
            alignItems="center"
          >
            {mapOnData()}
          </Grid>
        </Container>
        <AlertMessage
          open={alert.alertCheck}
          message={alert.message}
          duration={3000}
          close={handleClose}
          severity={alert.severity}
        />
      </Grid>
    </>
  );
}
